import { render } from "./RichTextEditor.vue?vue&type=template&id=45e5196d&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=45e5196d&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e5196d"]])

export default __exports__